import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import VFLottieView, { LottieTypes } from '@vfgroup-oneplatform/foundation/Components/VFLottieView';

import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './PaymentLottie.Styles';

const PaymentLottie = ({ type, isPaymentRequest, lottieID, isReward, lottieViewStyle }) => {
  return (
    <View testID={lottieID}>
      <VFLottieView
        style={[isReward ? styles.rewardLottieViewStyle : styles.lottieViewStyles, lottieViewStyle]}
        autoPlay
        loop={!!isPaymentRequest}
        type={type}
      />
    </View>
  );
};

PaymentLottie.defaultProps = {
  lottieID: FrameworkTestKeys.TPMainIcon,
  type: LottieTypes.spinner,
  lottieViewStyle: {},
};

PaymentLottie.propTypes = {
  source: PropTypes.object,
  isPaymentRequest: PropTypes.bool,
  isReward: PropTypes.bool,
  lottieID: PropTypes.string,
  type: PropTypes.oneOf(Object.values(LottieTypes)),
  lottieViewStyle: ViewPropTypes.style,
};
export default PaymentLottie;
